import React from 'react';

const ReportGroupContainer = ({ children }) => {
	return <div className="report-group-container">{children}</div>;
};

export default ReportGroupContainer;
